import type { CityConfig } from "../city-template/types";

export const tysonsVaConfig: CityConfig = {
  city: "Tysons",
  state: "Virginia",
  stateAbbr: "VA",
  slug: "tysons-va",
  route: "/cities/tysons-va",
  title: "Emergency Passport Tysons VA | Expedited Passport Services | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Tysons, VA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Tysons Corner, Metro Silver Line corridor, and Northern Virginia business district. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Tysons, VA",
  heroSubtitle: "Passport expired before your trip? Traveling from Tysons Corner, the Metro Silver Line corridor, or the Northern Virginia business district? We help Tysons travelers get expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Tysons%20Corner%20Virginia%20modern%20skyline%20with%20the%20Tysons%20Galleria%20and%20Tysons%20Corner%20Center%20shopping%20districts%2C%20sleek%20glass%20office%20towers%20and%20Metro%20Silver%20Line%20elevated%20tracks%2C%20urban%20business%20district%20with%20modern%20architecture%20and%20retail%20centers%2C%20warm%20afternoon%20light%20with%20tree-lined%20boulevards%20and%20Northern%20Virginia%20suburban%20development%2C%20professional%20photography%20showcasing%20this%20major%20commercial%20hub%20near%20Washington%20DC%2C%20no%20people%20visible%2C%20scenic%20urban%20landscape%20with%20contemporary%20high-rise%20buildings%20and%20transit%20infrastructure&width=1800&height=700&seq=tysons-va-hero-001&orientation=landscape",
  heroImageAlt: "Tysons Corner Virginia modern skyline with Metro Silver Line and glass office towers",
  geoPosition: "38.9187;-77.2311",
  geoPlacename: "Tysons, Virginia",
  regionalAgency: {
    name: "Washington Passport Agency",
    address: "600 19th Street NW, Washington, DC 20006",
    distance: "Located in downtown Washington, DC — approximately 15 miles southeast of Tysons via I-495 or the Metro Silver Line",
  },
  nearbyCitiesZips: [
    { name: "Tysons", zips: "22102, 22182" },
    { name: "Tysons Corner", zips: "22102, 22182" },
    { name: "McLean", zips: "22101, 22102, 22106" },
    { name: "Vienna", zips: "22180, 22181, 22182, 22183, 22185" },
    { name: "Falls Church", zips: "22041, 22042, 22043, 22044, 22046" },
    { name: "Fairfax", zips: "22030, 22031, 22032, 22033, 22034, 22035, 22036, 22037, 22038, 22039" },
    { name: "Reston", zips: "20190, 20191, 20194, 20195, 20196" },
    { name: "Herndon", zips: "20170, 20171, 20172, 20192" },
    { name: "Arlington", zips: "22201, 22202, 22203, 22204, 22205, 22206, 22207, 22209, 22211, 22213, 22214" },
    { name: "Alexandria", zips: "22301, 22302, 22304, 22305, 22311, 22312, 22314" },
    { name: "Springfield", zips: "22150, 22151, 22152, 22153, 22156, 22158, 22159, 22160, 22161" },
    { name: "Burke", zips: "22009, 22015, 22032" },
    { name: "Annandale", zips: "22003" },
    { name: "Oakton", zips: "22124" },
    { name: "Great Falls", zips: "22066" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent travel departures from Tysons Corner and the NoVA business district" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "NoVA Business District Hub", desc: "Serving Tysons Corner, McLean, Vienna, and the Metro Silver Line corridor" },
  ],
  internalLinks: [
    { name: "Virginia state passport services", route: "/states/virginia" },
    { name: "McLean VA passport services", route: "/cities/mclean-va" },
    { name: "Falls Church VA passport services", route: "/cities/falls-church-va" },
    { name: "Vienna VA passport services", route: "/cities/vienna-va" },
    { name: "Reston VA passport services", route: "/cities/reston-va" },
    { name: "Fairfax VA passport services", route: "/cities/fairfax-va" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Tysons remotely via secure courier. We do not have a walk-in office in Tysons — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Tysons and Northern Virginia business district travelers.",
  fpcOfficeDistance: "Serving all of Tysons Corner and the Northern Virginia business district including McLean, Vienna, Falls Church, Reston, Herndon, and the Metro Silver Line corridor",
  serviceAreaIntro: "From the towering glass office buildings of Tysons Corner to the upscale neighborhoods of McLean, from the transit-connected communities along the Metro Silver Line to the charming streets of Vienna, from the bustling retail corridors of Tysons Galleria and Tysons Corner Center to the quiet residential areas of Great Falls and Oakton — Fast Passport Center serves every corner of Tysons and the Northern Virginia business district. We regularly help travelers from McLean, Vienna, Falls Church, and Reston get their passports fast.",
  nearbyCitiesIntro: "We serve all Tysons neighborhoods and the Northern Virginia business district including McLean, Vienna, Falls Church, Reston, Herndon, Annandale, and the Metro Silver Line corridor.",
  howItWorksIntro: "Most Tysons travelers complete everything online and ship documents overnight. No need to drive to the Washington regional agency or wait in long government lines.",
  mistakesIntro: "Tysons travelers often face the temptation to drive to the Washington regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Tysons and Northern Virginia business district travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Tysons? Here are the most common ones we hear from Northern Virginia business district travelers.",
  statePageRoute: "/states/virginia",
  statePageName: "Virginia",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–3",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Tysons international flights and last-minute travel.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "David K.",
      location: "Tysons, VA",
      rating: 5,
      text: "I work in the Tysons business district and needed an emergency passport for a client meeting in Singapore with 4 days notice. Fast Passport Center had my renewal in 3 days. I shipped from the FedEx near Tysons Corner Center and it was completely seamless. No need to leave the office for a DC trip.",
      service: "Emergency Passport",
    },
    {
      name: "Sarah M.",
      location: "McLean, VA",
      rating: 5,
      text: "As a McLean resident, I was worried about finding expedited passport services close to home. Fast Passport Center made it incredibly easy. Everything was done online, and my renewal was back in 4 days. The convenience for Northern Virginia professionals is unbeatable.",
      service: "Passport Renewal",
    },
    {
      name: "James L.",
      location: "Tysons, VA",
      rating: 5,
      text: "First passports for my three kids before a family trip to Japan. Fast Passport Center handled all the parental consent requirements perfectly and had all three passports in 5 days. For Tysons families, this is the best expedited passport service available.",
      service: "Child Passport",
    },
    {
      name: "Amanda R.",
      location: "Vienna, VA",
      rating: 5,
      text: "Lost my passport 3 days before a conference in Berlin. I was in absolute panic. Fast Passport Center had a replacement in my hands in 40 hours. They saved my presentation and my business trip. Vienna professionals need this service.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "tysons-va-1",
      name: "McLean Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1361 Chain Bridge Road",
      city: "McLean",
      state: "VA",
      zip: "22101",
      phone: "(703) 893-0303",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "McLean, adjacent to Tysons",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary facility near Tysons Corner. Full passport services with appointment. Call ahead to confirm.",
      icon: "ri-mail-line",
    },
    {
      id: "tysons-va-2",
      name: "Vienna Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "200 Lawyers Road NW",
      city: "Vienna",
      state: "VA",
      zip: "22180",
      phone: "(703) 938-4761",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM; Sat: 9:00 AM – 12:00 PM",
      distance: "Vienna, west of Tysons",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Vienna and western Tysons area. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "tysons-va-3",
      name: "Falls Church Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "223 W Broad Street",
      city: "Falls Church",
      state: "VA",
      zip: "22046",
      phone: "(703) 534-5304",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM; Sat: 9:00 AM – 12:00 PM",
      distance: "Falls Church, south of Tysons",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Falls Church and southern Tysons area. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "tysons-va-4",
      name: "Fairfax Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "4000 Chain Bridge Road",
      city: "Fairfax",
      state: "VA",
      zip: "22030",
      phone: "(703) 385-7283",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM; Sat: 9:00 AM – 12:00 PM",
      distance: "Fairfax, southwest of Tysons",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Fairfax and southwestern Tysons area. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "tysons-va-5",
      name: "Reston Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "11110 Sunset Hills Road",
      city: "Reston",
      state: "VA",
      zip: "20190",
      phone: "(703) 471-8984",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Reston, northwest of Tysons",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Reston and northwestern Tysons area. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "tysons-va-6",
      name: "Fairfax County Clerk",
      type: "County Clerk",
      address: "4110 Chain Bridge Road",
      city: "Fairfax",
      state: "VA",
      zip: "22030",
      phone: "(703) 691-7320",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Fairfax, near Tysons",
      website: "https://www.fairfaxcounty.gov/circuit",
      websiteLabel: "Fairfax County Clerk",
      notes: "Provides vital records and birth certificates. Not a passport acceptance facility but useful for document collection.",
      icon: "ri-building-2-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — Metro or drive to DC", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Tysons photo shops often use generic sizes. Passport photos must be exactly 2x2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Northern Virginia acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Tysons applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Washington DC regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Tysons families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Tysons travelers often assume standard processing will be fine. It takes 8-11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx location near Tysons Corner." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Tysons address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Tysons before my international trip?", a: "Yes. Fast Passport Center provides emergency passport services in Tysons for travelers with urgent international departures. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24-48 hour turnaround — perfect for last-minute trips from the Northern Virginia business district." },
    { q: "How fast can I renew my passport in Tysons?", a: "Fast Passport Center offers fast passport renewal in Tysons in as little as 24-48 hours through our emergency courier service. For less urgent travel, our 3-5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Tysons?", a: "The nearest regional passport agency to Tysons is the Washington Passport Agency, located approximately 15 miles southeast in downtown Washington, DC. Accessible via I-495 or the Metro Silver Line. For urgent processing without the commute, Fast Passport Center's registered courier service achieves 24-48 hour turnaround from Tysons." },
    { q: "Can I get a same-day passport appointment near Tysons?", a: "Same-day passport appointments are only available at the Washington Regional Passport Agency for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24-48 hour emergency courier processing is the fastest guaranteed option for Tysons residents." },
    { q: "Can I expedite a child passport in Tysons?", a: "Yes. Fast Passport Center expedites child passports in Tysons for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Tysons and Northern Virginia families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Tysons with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24-48 hours." },
    { q: "How fast can I get a passport in Tysons?", a: "With Fast Passport Center's emergency courier service, Tysons travelers can receive their passport in as little as 24-48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays." },
    { q: "Do I need to drive to the Washington Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
    { q: "Where are the closest passport acceptance facilities near Tysons?", a: "Popular options include the McLean Post Office (22101), Vienna Post Office (22180), Falls Church Post Office (22046), and Fairfax Main Post Office (22030). All require appointments. We help you find the most convenient location and schedule your visit." },
    { q: "What if I live in McLean or Vienna?", a: "We serve the entire Tysons area including McLean, Vienna, Falls Church, Reston, Herndon, and Oakton. Our overnight shipping labels work from any UPS or FedEx location, so your location doesn't affect processing speed." },
    { q: "How much does expedited passport service cost in Tysons?", a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24-48 hour processing, 3-5 day expedited, or standard options. Contact us for a personalized quote." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Tysons", address: "8150 Leesburg Pike, Vienna, VA 22182", hours: "Mon-Sun: 8AM-10PM" },
    { name: "Walgreens — McLean", address: "1369 Chain Bridge Rd, McLean, VA 22101", hours: "Mon-Sun: 7AM-11PM" },
    { name: "FedEx Office — Tysons", address: "1800 Tysons Blvd, McLean, VA 22102", hours: "Mon-Fri: 7AM-9PM, Sat: 8AM-6PM" },
    { name: "CVS Pharmacy — Vienna", address: "400 Maple Ave E, Vienna, VA 22180", hours: "Mon-Sun: 8AM-10PM" },
    { name: "Walgreens — Falls Church", address: "3100 Graham Rd, Falls Church, VA 22042", hours: "Mon-Sun: 7AM-11PM" },
    { name: "CVS Pharmacy — Fairfax", address: "10430 Fairfax Blvd, Fairfax, VA 22030", hours: "Mon-Sun: 8AM-10PM" },
  ],
  dmvLocations: [
    {
      name: "Virginia DMV — Tysons",
      address: "1800 Tysons Blvd, McLean, VA 22102",
      hours: "Mon-Fri: 8AM-5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "Virginia DMV — Fairfax",
      address: "10255 Main St, Fairfax, VA 22030",
      hours: "Mon-Fri: 8AM-5PM",
      note: "REAL ID and passport-related ID services. Appointment strongly recommended.",
      featured: false,
    },
    {
      name: "Virginia DMV — Vienna",
      address: "200 Lawyers Rd NW, Vienna, VA 22180",
      hours: "Mon-Fri: 8AM-5PM",
      note: "Serves Vienna and Tysons area. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "DCA",
      name: "Ronald Reagan Washington National Airport",
      distance: "Approximately 14 miles southeast of Tysons",
      address: "2401 Smith Blvd, Arlington, VA 22202",
      note: "The closest major airport to Tysons. Domestic and international flights. Accessible via Metro Silver Line or I-495.",
      flightUrl: "https://www.flyreagan.com/",
      flightLabel: "DCA Airport",
      featured: true,
    },
    {
      code: "IAD",
      name: "Washington Dulles International Airport",
      distance: "Approximately 15 miles west of Tysons",
      address: "1 Saarinen Cir, Dulles, VA 20166",
      note: "Major international hub for the DC metro area. Accessible via Route 7 or the Silver Line.",
      flightUrl: "https://www.flydulles.com/",
      flightLabel: "IAD Airport",
      featured: false,
    },
    {
      code: "BWI",
      name: "Baltimore/Washington International Airport",
      distance: "Approximately 50 miles northeast of Tysons",
      address: "7050 Friendship Rd, Baltimore, MD 21240",
      note: "Alternative international hub for DC area travelers. Accessible via I-95.",
      flightUrl: "https://www.bwiairport.com/",
      flightLabel: "BWI Airport",
      featured: false,
    },
  ],
};